<template>
    <div class="base-login-form flex">
        <h2 class="login-title">
            Sign In
        </h2>
        <p class="welcome-text">
            Don’t have an account? <a @click="goToRegister">Create a free one.</a>
        </p>
        <form
            id="login"
            novalidate
            @submit.prevent="processForm"
        >
            <div
                v-if="loginErrorMessage"
                class="form-error"
            >
                {{ loginErrorMessage }}
            </div>
            <fieldset
                :class="{ error: emailErrorMessage || loginErrorMessage }"
            >
                <input
                    id="email"
                    v-model="user.email"
                    type="email"
                    name="email"
                    placeholder="Email"
                    autocomplete="off"
                    :class="{ error: emailErrorMessage || loginErrorMessage }"
                    @click="clearError()"
                >
                <label for="email">
                    Email address
                </label>
            </fieldset>
            <span
                v-if="emailErrorMessage"
                class="form-error"
            >
                {{ emailErrorMessage }}
            </span>
            <fieldset
                :class="{ error: emailErrorMessage || loginErrorMessage }"
            >
            <input
                id="password"
                v-model="user.password"
                placeholder="Password"
                type="password"
                name="password"
                autocomplete="off"
                :class="{ error: emailErrorMessage || loginErrorMessage }"
                @click="clearError"
                >
                <label for="password">
                    Password
                </label>
            </fieldset>
            <span
                v-if="passwordErrorMessage"
                class="form-error"
            >
                {{ passwordErrorMessage }}
            </span>
             <base-form-button
                :class="'btn'"
                :loading="formProcessing || false"
            >
                Sign In
            </base-form-button>
        </form>
        <a
            class="reset-link"
            @click="goToPasswordReset"
        >
            Forgot your password?
        </a>
    </div>
</template>

<script>
import { passwordValidator, emailValidator } from '@/utils/form/validation';
import apiCall from '@/utils/apiCall';
import { loginRedirect } from '@/utils/redirect';
import extractUrlParam from '@/utils/extractUrlParam';

export default {
    data: () => ({
        user: {
            email: '',
            password: '',
        },
        loginErrorMessage: null,
        emailErrorMessage: null,
        passwordErrorMessage: null,
        formProcessing: false,
    }),

    /**
     * Created hook
     */
    created() {
        this.user.email = extractUrlParam('email');
    },

    methods: {
        /**
         * Validates form data and call login method
         *
         */
        processForm() {
            const { email, password } = this.user;

            if (! emailValidator(email)) {
                this.emailErrorMessage = 'Please enter valid email adress';
            }

            const passwordValidation = passwordValidator(password);

            if (! passwordValidation.validation) {
                this.passwordErrorMessage = passwordValidation.message;
            }

            if (this.passwordErrorMessage || this.emailErrorMessage) {
                return;
            }

            this.login(this.user);
        },

        /**
         * Clears error data
         *
         */
        clearError() {
            this.loginErrorMessage = null;
            this.emailErrorMessage = null;
            this.passwordErrorMessage = null;
        },

        /**
         * Handle user login process
         *
         * @param   {object}  user      User data.
         * @param   {string}  user.email     User email.
         * @param   {string}  user.password  User password.
         *
         */
        async login({ email, password }) {
            const { data: { errors, message }, status } = await apiCall(this, 'post', 'api/user/login', { email, password });

            this.formProcessing = false;

            if (422 === status) {
                this.loginErrorMessage = errors.email[0] ?? message;
            } else {
                loginRedirect();
            }
        },

        /**
         * Redirect user to register route
         *
         */
        goToRegister() {
            this.$router.push('register');
        },

        /**
         * Redirect user to password reset
         *
         */
        goToPasswordReset() {
            this.$router.push('password/email');
        },
    },
};
</script>
